export default "__VITE_ASSET__UwMUrnug__"